<template>
  <v-card>
    <v-progress-linear
      absolute
      :active="loading"
      indeterminate
      color="primary"
      bottom
    ></v-progress-linear>
    <v-card-title>
      <span class="headline">Create Transaction</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <transaction-form
          :status="Object.values(item).length > 0 ? 'update' : 'create'"
          :data="data"
        ></transaction-form>
      </v-container>
    </v-card-text>
    <form-errors :errors="errors"></form-errors>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="_close">Cancel</v-btn>
      <v-btn
        :disabled="loading"
        v-if="Object.values(item).length > 0"
        color="blue darken-1"
        text
        @click="update"
        >Update</v-btn
      >
      <v-btn
        :disabled="loading"
        v-else
        color="blue darken-1"
        text
        @click="create"
        >Create</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import FormErrors from '../../../../components/FormErrors'
import TransactionForm from './TransactionForm'
import { axios } from '../../../../utils'
export default {
  name: 'TransactionDialog',
  data() {
    return {
      data: {
        first: false,
        last: false,
        paid: false,
        transactionDate: '',
        amount: null,
        approvalNo: null,
        payment_method: null,
        repeat_transaction: undefined,
        gap_duration: undefined
      },
      loading: false,
      errors: []
    }
  },
  props: ['close', 'transactions', 'item', 'client_id'],
  components: {
    TransactionForm,
    FormErrors
  },
  mounted() {
    if (this.item.id) {
      this.loading = true
      console.log('getting transaction data for id ', this.item.id)
      axios
        .get('api/admin/transactions/' + this.item.id)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this.data = res.data
          this.data.approvalNo = res.data.approval_no
          this.data.transactionDate = res.data.transaction_date
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false))
    }
  },
  methods: {
    create() {
      this.loading = true
      this.errors = []
      console.log('creating new transaction')
      if (
        (this.data.repeat_transaction !== undefined &&
          this.data.gap_duration !== undefined) ||
        (this.data.repeat_transaction === undefined &&
          this.data.gap_duration === undefined)
      ) {
        axios
          .post('api/admin/transactions/create', {
            ...this.data,
            client_id: this.client_id
          })
          .then(res => {
            console.log(res.data)
            console.log('done')
            this._close()
          })
          .catch(err => {
            if (err.response.status === 422) {
              this.errors = Object.values(err.response.data.errors)
            } else {
              console.log(err.response)
            }
          })
          .finally(() => (this.loading = false))
      } else {
        this.loading = false
        this.errors.push([
          'Please select repeat transaction and gap duration both or make both empty'
        ])
      }
    },
    update() {
      this.loading = true
      console.log('updating transaction data for id ', this.item.id)
      axios
        .put(`api/admin/transactions/${this.item.id}`, {
          ...this.data,
          client_id: this.client_id
        })
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    _close() {
      this.clearData()
      this.close()
    },
    clearData() {
      this.data = {
        first: false,
        last: false,
        paid: false,
        transactionDate: '',
        amount: null,
        approvalNo: null,
        payment_method: null,
        repeat_transaction: undefined,
        gap_duration: undefined
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
